// Adaption from https://gist.github.com/barkibu-dev-team/0f22bf035ed0fa07826f0c4efdf903b4

import { getCookieValue, getWindow } from "@utils/browser-features";
import { transformKeys } from "@utils/utils";

const UTM_KEYS = [
  "utm_adgroup_id",
  "utm_adgroup",
  "utm_campaign_id",
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term",
];
const COMPANY_ROOT_DOMAIN = "barkibu.com";
const IRRELEVANT_REFERRER_HOSTS = ["docuten", "stripe"];

export type Utms = Record<string, string | null>;

export const getAllUtmsPrefixed = (): Utms => {
  const firstUtms = getFirstUtms();
  const prefixedFirstUtms = transformKeys(firstUtms, (key) => `first_${key}`);
  const lastUtms = getLastUtms();
  const prefixedLastUtms = transformKeys(lastUtms, (key) => `last_${key}`);

  return {
    ...prefixedFirstUtms,
    ...prefixedLastUtms,
  };
};

export const getFirstUtms = (): Utms => {
  let utms = getUtmsFromCookies("first");
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  utms = getUtmsFromQueryParams();
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  utms = getUtmsFromReferrer();
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  return {};
};

export const getLastUtms = (): Utms => {
  let utms = getUtmsFromQueryParams();
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  utms = getUtmsFromCookies("last");
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  utms = getUtmsFromReferrer();
  if (Object.keys(utms).length > 0) {
    return utms;
  }

  return {};
};

export const getUtmsFromQueryParams = (): Utms => {
  const window = getWindow();
  if (!window) {
    return {};
  }

  const urlParams = new URLSearchParams(window.location.search);

  const utms = {};
  UTM_KEYS.forEach((utmKey) => {
    const utmValue = urlParams.get(utmKey);
    if (utmValue) {
      utms[utmKey] = encodeURIComponent(utmValue);
    }
  });

  return utms;
};

const getUtmsFromReferrer = (): Utms => {
  const window = getWindow();
  if (!window) {
    return {};
  }

  if (window.document.referrer === "") {
    return {
      utm_medium: "none",
      utm_source: "direct",
    };
  }

  const referrerHostname = new URL(window.document.referrer).hostname;
  const referrerIsFromCompany = referrerHostname.endsWith(`.${COMPANY_ROOT_DOMAIN}`);
  const referrerIsIrrelevant = IRRELEVANT_REFERRER_HOSTS.some((irrelevantHost) =>
    referrerHostname.includes(irrelevantHost)
  );
  if (referrerIsFromCompany || referrerIsIrrelevant) {
    return {};
  }

  return {
    utm_source: referrerHostname,
    utm_medium: "organic",
  };
};

const getUtmsFromCookies = (prefix: string): Utms => {
  const utms = getCookieValue(`${prefix}Utms`);
  if (!utms || utms === "") {
    return {};
  }

  return JSON.parse(utms) as Utms;
};
